<template>
    <div id="headers">
        <div class="headersImg" @click="returnPage"><img src="../assets/images/img_31.png" alt=""></div>
        <div class="headerText">{{headersText}}</div>
    </div>
</template>

<script>
    export default {
        props:['headersText'],
        computed: {

        },
        data() {
            return {
                
            }
        },
        methods: {
            returnPage:function(){
                this.$router.go(-1);
            }
        },
    }
</script>

<style lang="less" scoped>
    #headers{
        width: 375px;
        height: 45px;
        background: #E50113;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        .headersImg{
            width: 11px;
            height: 18px;
            position: absolute;
            left: 15px;
            padding: 0 3px;
            img{
                width: 11px;
                height: 18px;
            }
        }
        
        .headerText{
            font-size: 15px;
            color: #FFFFFF;
        }
    }
</style>